import { Box, Typography } from '@mui/material';
import CopyableTextMUI from 'components/shared/CopyableText/CopyableText';
import { formatDealAmount } from 'helper/short-currency';
import zeplinColor from 'theme/Color';
import { Utilities } from 'utilities/utilities';
import { IconMap } from './data';
import { muiStyles } from './muiStyles';
import { formatKeysToDisplay } from './utils';

const formatValue = (val: any, key?: string) => {
  if (val === null || val === undefined) return 'N/A';
  if (key?.toLowerCase().includes('revenue') || key?.toLowerCase().includes('revenue')) {
    return formatDealAmount(val);
  }
  if (key?.toLowerCase().includes('phone')) {
    return <CopyableTextMUI textToCopy={val} />;
  }
  if (key?.includes('primaryIndustry')) return val[0];
  if (typeof val === 'number') return val.toLocaleString();
  if (Array.isArray(val))
    return (
      <Box key={key} sx={{ display: 'flex', gap: '8px' }}>
        {val.map(
          (item: {
            type: 'LINKED_IN' | 'FACEBOOK' | 'TWITTER';
            followerCount: string;
            url: string;
          }) => {
            const Icon = IconMap[item.type];

            return (
              <Box>
                <a href={item.url} target='_blank' rel='noreferrer noopener'>
                  <img src={Icon} width={'18px'} height={'18px'} alt={item.type} />
                </a>
              </Box>
            );
          },
        )}
      </Box>
    );

  return val;
};

const CompanyDetail = ({ data }: { data: any }) => {
  const keysToDisplay = formatKeysToDisplay(data);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '20px', xl: '32px' },
        height: 'calc(100vh - 310px)',
      }}
    >
      <Box sx={muiStyles.container}>
        <Typography variant='responsiveHeading3'>Company Details</Typography>
        <Box sx={muiStyles.contentGrid}>
          {keysToDisplay.map((key) => {
            return (
              <Box key={key} sx={muiStyles.gridItem}>
                <Typography variant='responsiveBody3'>{formatValue(data[key], key)}</Typography>
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                  {Utilities.camelCaseToTitleCase(key)}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default CompanyDetail;
